<template>
    <q-option-group :options="options" type="checkbox" :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)" :error="error" :loading="loading" :disable="loading"
        outlined>
        <template v-slot:label="opt">
            <div class="row items-center">
                <span>{{ opt.label }}</span>
                <q-icon name="mdi-square" :style="`color: ${useStringToColor(opt.label)};`" size="1.5em" class="q-ml-sm" />
            </div>
        </template>
    </q-option-group>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import HelperListService from "@/services/HelperListService";
import { useStringToColor } from "@/composables/useStringToColor";
const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([]);
let defaultOptions = [];
const error = computed(() => props.errors && props?.errors?.length !== 0);
const loading = ref(false);

onMounted(async () => {
    loading.value = true;
    defaultOptions = await HelperListService.grupoProductosWeb();
    options.value = defaultOptions.map((item) => ({
        label: item.label.trim(),
        value: item.value.trim(),
    }));
    loading.value = false;
});
</script>
